import { AgentsMyAgentPage } from 'app/components/agents-hub/AgentsMyAgentPage'

export const handle = {
  title: `Agents · Settings`,
  breadcrumb: `Settings`,
}

export default function AgentsSettingsRoute() {
  return <AgentsMyAgentPage />
}
